import { FC } from 'react'
import { RouteObject } from 'react-router-dom'
import { Packs } from '../features/packs-page'
import { Segment } from '../features/segment'

const PacksPage: FC = () => (
  <Segment.ViewTracker attributes={{ path: '/sounds' }}>
    <Packs />
  </Segment.ViewTracker>
)

export const PacksRoute: RouteObject = {
  path: '/packs',
  element: <PacksPage />
}
